import React, { forwardRef } from 'react';
import PropTypes        from 'prop-types';
import { Link }         from 'react-router-dom';
// import classNames       from 'classnames';

import AvailabilityBG   from '../../../../../assets/images/availability.jpg';
import Icon             from '../../../../../assets/images/Icon.jpg';

import styles           from './AvailabilityBlock.styl';

function AvailabilityBlock(props, ref) {
    // const {  } = props;

    // const {} = useMessage();

    return  (
        <section
            className={styles.AvailabilityBlock}
            ref = {ref}
        >
            <div className={styles.leftBlock}>
                <div className={styles.blockName}>
                    <span className={styles.dot} />
                    Availability
                </div>
                <h2 className={styles.blockTitle}>
                Make a Closed Beta Request and see Roimax in Action
                </h2>
                <h3 className={styles.description}>
                    The insights that matter are the ones that you can trust and act on. Our platform gives you the accurate and actionable insights that help you build better customer relationships.
                </h3>
                <div className={styles.dataBlock}>
                    <div className={styles.dataText}>
                        Ready to start making good choices?
                    </div>
                    <Link
                        to        = '/create-account'
                        className = {styles.buttonLink}
                    >
                        <div className={styles.startButton}>
                        Start your free trial now
                            <img src={Icon} className={styles.icon} />
                        </div>
                    </Link>
                </div>
            </div>
            <div className={styles.rightBlock}>
                <img
                    src       = {AvailabilityBG}
                    className = {styles.blockImage}
                />
            </div>
        </section>
    );
}

AvailabilityBlock.propTypes = {
    className : PropTypes.string,
    message   : PropTypes.string
};

AvailabilityBlock.defaultProps = {
    className : '',
    message   : ''
};

export default forwardRef(AvailabilityBlock);
